// extracted by mini-css-extract-plugin
module.exports = {"we":"We_we__J5I1Q","our_beliafs":"We_our_beliafs__18TU-","box_p":"We_box_p__2ayPJ"};